import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-65e20c1a")

_pushScopeId("data-v-65e20c1a")
const _hoisted_1 = { class: "kn-list-item-text" }
const _hoisted_2 = { class: "p-text-uppercase" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_Card = _resolveComponent("Card")

  return (_ctx.dataset)
    ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
        header: _withId(() => [
          _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
            start: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.dataset.name), 1)
            ]),
            _: 1
          })
        ]),
        content: _withId(() => [
          _createVNode(_component_Listbox, {
            class: "metafield-list",
            modelValue: _ctx.selectedMetafield,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedMetafield = $event)),
            options: _ctx.dataset.metadata.fieldsMeta,
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.metafieldsSelected($event.value)))
          }, {
            empty: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
            ]),
            option: _withId((slotProps) => [
              _createVNode("div", {
                class: ["kn-list-item p-d-flex p-flex-row", { ' selected-metafield': slotProps.option.selected }]
              }, [
                _createVNode("div", _hoisted_1, [
                  _createVNode("span", _hoisted_2, _toDisplayString(slotProps.option.name), 1)
                ])
              ], 2)
            ]),
            _: 1
          }, 8, ["modelValue", "options"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
})